import { render, staticRenderFns } from "./EventRegistrationLegacy.vue?vue&type=template&id=4b71ab16&scoped=true"
import script from "./EventRegistrationLegacy.vue?vue&type=script&lang=js"
export * from "./EventRegistrationLegacy.vue?vue&type=script&lang=js"
import style0 from "./EventRegistrationLegacy.vue?vue&type=style&index=0&id=4b71ab16&prod&lang=css"
import style1 from "./EventRegistrationLegacy.vue?vue&type=style&index=1&id=4b71ab16&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b71ab16",
  null
  
)

export default component.exports